import { AnchorLink } from 'components/anchorLink';
import { Skeleton } from 'components/skeleton';
import { useLazyGetCorseIppicaUltimiRisultatiQuery } from 'features/api/ippicaApiSlice';
import { IppicaUltimiRisultatiCard } from '../ippicaUltimiRisultatiCard';
import styles from './IppicaBgContainer.module.scss';
import { isTruthy } from 'utility/functions';
import React, { useEffect } from 'react';
import { isServerSide } from 'utility/constant';

export type IppicaBgContainerProps = {
  hasMarginBottom?: boolean;
  label: string;
};

export const IppicaBgContainer = ({ label, hasMarginBottom }: IppicaBgContainerProps) => {
  const [trigger, { data, isLoading }] = useLazyGetCorseIppicaUltimiRisultatiQuery();

  useEffect(() => {
    if (isServerSide) return;
    trigger(undefined);
  }, []);

  if (isServerSide || isLoading) {
    return <Skeleton />;
  }

  if (!isTruthy(data?.length)) {
    return <React.Fragment key={`IppicaBgContainer-${label}`} />;
  }

  return (
    <section
      className={`${styles.container} ${hasMarginBottom ? styles.withMarginBottom : ''}`}
      suppressHydrationWarning
    >
      <div className={styles.titleContainer} suppressHydrationWarning>
        <h2 className={styles.title}>{label}</h2>
        <AnchorLink href={process.env.NEXT_PUBLIC_IPPICA_RISULTATI_PARTENTI!} className={styles.link}>
          vedi tutti
        </AnchorLink>
      </div>
      <div className={styles.cardContainer}>
        {data?.map((item, index) => {
          return (
            <IppicaUltimiRisultatiCard
              key={`${item.codiceProgramma}-${item.codiceRiunione}-${index}`}
              item={item}
              containerClassName={styles.card}
            />
          );
        })}
      </div>
    </section>
  );
};
